import React, { useContext } from 'react';
import styles from '../../css/functional.module.scss';
import SearchContext from '../data/FunnelbackContext';

function Comparisons() {
    const { isFetching, localStorageState, resetComparisons, resetSingleComparison, comparisons } = useContext(SearchContext);

    if (isFetching) {
        return (
            <>
                <div className="sr-only">Loading...</div>
                {[...Array(5)].map((item, index) => (
                    <div
                        className="funnelback-instant-search-generic-result--loading"
                        // eslint-disable-next-line react/no-array-index-key
                        key={`result-${index}`}
                    />
                ))}
            </>
        );
    }

    if (localStorageState?.comparisons.length === 0) {
        return (
            <div className={`${styles.Comparisons} funnelback-instant-search-comparisons no-wysiwyg`}>
                <div className={`${styles.ComparisonsTop} funnelback-instant-search-comparisons-top`}>
                    <img src={comparisons?.bannerImage || ''} alt={comparisons?.bannerAlt || ''} />
                    <div className={`${styles.ComparisonsTopInner} funnelback-instant-search-comparisons-top-inner`}>
                        <h1>Uncover a world of possibility</h1>
                        <div>
                            <button
                                className={`${styles.ComparisonsClearButton} funnelback-instant-search-comparisons-top-clear-button`}
                                type="button"
                                onClick={() => {
                                    resetComparisons();
                                }}
                            >
                                <svg>
                                    <title>Clear all comparisons</title>
                                    <use href="#trash" />
                                </svg>
                                Clear all list
                            </button>
                            <a href={comparisons.secondaryButtonLink || ''}>
                                <button
                                    className={`${styles.ComparisonsFindButton} funnelback-instant-search-comparisons-top-find-button`}
                                    type="button"
                                >
                                    <svg>
                                        <title>{comparisons.secondaryButtonText || ''}</title>
                                        <use href="#search" />
                                    </svg>
                                    {comparisons.secondaryButtonText || ''}
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
                <div className={`${styles.ComparisonsNoResults} funnelback-instant-search-comparisons-no-results`}>
                    <h2>You have not added any comparisons.</h2>
                </div>
            </div>
        );
    }

    return (
        <div className={`${styles.Comparisons} funnelback-instant-search-comparisons no-wysiwyg`}>
            <div className={`${styles.ComparisonsTop} funnelback-instant-search-comparisons-top`}>
                <img src={comparisons?.bannerImage || ''} alt={comparisons?.bannerAlt || ''} />
                <div className={`${styles.ComparisonsTopInner} funnelback-instant-search-comparisons-top-inner`}>
                    <h1>Uncover a world of possibility</h1>
                    <div>
                        <button
                            className={`${styles.ComparisonsClearButton} funnelback-instant-search-comparisons-top-clear-button`}
                            type="button"
                            onClick={() => {
                                resetComparisons();
                            }}
                        >
                            <svg>
                                <title>Clear all comparisons</title>
                                <use href="#trash" />
                            </svg>
                            Clear all list
                        </button>
                        <a href={comparisons.secondaryButtonLink || ''}>
                            <button
                                className={`${styles.ComparisonsFindButton} funnelback-instant-search-comparisons-top-find-button`}
                                type="button"
                            >
                                <svg>
                                    <title>{comparisons.secondaryButtonText || ''}</title>
                                    <use href="#search" />
                                </svg>
                                {comparisons.secondaryButtonText || ''}
                            </button>
                        </a>
                    </div>
                </div>
            </div>
            <div className={`${styles.ComparisonsTable} funnelback-instant-search-comparisons-table`}>
                <div className={`${styles.ComparisonsTableInner} funnelback-instant-search-comparisons-table-inner`}>
                    <table>
                        <tbody>
                            <tr>
                                <th className={`${styles.ComparisonsTableHeadings} funnelback-instant-search-comparisons-table-headings`}>
                                    {' '}
                                </th>
                                {localStorageState?.comparisons.map((object) => (
                                    <td>
                                        <div
                                            className={`${styles.ComparisonsTableApplyRow} funnelback-instant-search-comparisons-table-apply-row`}
                                        >
                                            <a href={object?.liveUrl || ''} target="_blank" rel="noreferrer">
                                                <button
                                                    type="button"
                                                    className={`${styles.ComparisonsTableApplyButton} funnelback-instant-search-comparisons-table-apply-button`}
                                                >
                                                    <svg>
                                                        <title>Check Icon</title>
                                                        <use href="#check" />
                                                    </svg>
                                                    Apply now
                                                </button>
                                            </a>
                                            <button
                                                className={`${styles.ComparisonsTableRemoveButton} funnelback-instant-search-comparisons-table-remove-button`}
                                                type="button"
                                                onClick={() => {
                                                    resetSingleComparison(object.liveUrl);
                                                }}
                                            >
                                                <svg>
                                                    <title>Remove comparison from your comparisions list</title>
                                                    <use href="#close" />
                                                </svg>
                                            </button>
                                        </div>
                                    </td>
                                ))}
                            </tr>
                            <tr>
                                <th className={`${styles.ComparisonsTableHeadings} funnelback-instant-search-comparisons-table-headings`}>
                                    <h3>Course overview</h3>
                                </th>
                                {localStorageState?.comparisons.map((object) => (
                                    <td>
                                        <h2>{object?.listMetadata?.programCredentialName || ''}</h2>
                                        <h3
                                            className={`${styles.ComparisonsTableMobileContent} funnelback-instant-search-comparisons-table-mobile-content`}
                                        >
                                            Course overview
                                        </h3>
                                        <p>{object?.summary || ''}</p>
                                    </td>
                                ))}
                            </tr>
                            <tr>
                                <th className={`${styles.ComparisonsTableHeadings} funnelback-instant-search-comparisons-table-headings`}>
                                    <h3>Study level</h3>
                                </th>
                                {localStorageState?.comparisons.map((object) => (
                                    <td>
                                        <h3
                                            className={`${styles.ComparisonsTableMobileContent} funnelback-instant-search-comparisons-table-mobile-content`}
                                        >
                                            Study level
                                        </h3>
                                        <p>{object?.listMetadata?.programCredentialType || ''}</p>
                                    </td>
                                ))}
                            </tr>
                            <tr>
                                <th className={`${styles.ComparisonsTableHeadings} funnelback-instant-search-comparisons-table-headings`}>
                                    <h3>Eligibility</h3>
                                </th>
                                {localStorageState?.comparisons.map((object) => (
                                    <td>
                                        <h3
                                            className={`${styles.ComparisonsTableMobileContent} funnelback-instant-search-comparisons-table-mobile-content`}
                                        >
                                            Eligibility
                                        </h3>
                                        <p>{object?.listMetadata?.programEligibility || ''}</p>
                                    </td>
                                ))}
                            </tr>
                            <tr>
                                <th className={`${styles.ComparisonsTableHeadings} funnelback-instant-search-comparisons-table-headings`}>
                                    <h3>Study mode</h3>
                                </th>
                                {localStorageState?.comparisons.map((object) => (
                                    <td>
                                        <h3
                                            className={`${styles.ComparisonsTableMobileContent} funnelback-instant-search-comparisons-table-mobile-content`}
                                        >
                                            Study mode
                                        </h3>
                                        <p>{object?.listMetadata?.stencilsDeliveryMethod || ''}</p>
                                    </td>
                                ))}
                            </tr>
                            <tr>
                                <th className={`${styles.ComparisonsTableHeadings} funnelback-instant-search-comparisons-table-headings`}>
                                    <h3>Location</h3>
                                </th>
                                {localStorageState?.comparisons.map((object) => (
                                    <td>
                                        <h3
                                            className={`${styles.ComparisonsTableMobileContent} funnelback-instant-search-comparisons-table-mobile-content`}
                                        >
                                            Location
                                        </h3>
                                        <p>{object?.listMetadata?.programCampus || ''}</p>
                                    </td>
                                ))}
                            </tr>
                            <tr>
                                <th className={`${styles.ComparisonsTableHeadings} funnelback-instant-search-comparisons-table-headings`}>
                                    <h3>Duration</h3>
                                </th>
                                {localStorageState?.comparisons.map((object) => (
                                    <td>
                                        <h3
                                            className={`${styles.ComparisonsTableMobileContent} funnelback-instant-search-comparisons-table-mobile-content`}
                                        >
                                            Duration
                                        </h3>
                                        <p>{object?.listMetadata?.programLengthYears || ''}</p>
                                    </td>
                                ))}
                            </tr>
                            <tr>
                                <th className={`${styles.ComparisonsTableHeadings} funnelback-instant-search-comparisons-table-headings`}>
                                    <h3>Fees</h3>
                                </th>
                                {localStorageState?.comparisons.map((object) => (
                                    <td>
                                        <h3
                                            className={`${styles.ComparisonsTableMobileContent} funnelback-instant-search-comparisons-table-mobile-content`}
                                        >
                                            Fees
                                        </h3>
                                        <p>{object?.listMetadata?.programFees || ''}</p>
                                    </td>
                                ))}
                            </tr>
                            <tr>
                                <th className={`${styles.ComparisonsTableHeadings} funnelback-instant-search-comparisons-table-headings`}>
                                    <h3>Possible careers</h3>
                                </th>
                                {localStorageState?.comparisons.map((object) => {
                                    if (object?.listMetadata?.programCareers) {
                                        return (
                                            <td>
                                                <h3
                                                    className={`${styles.ComparisonsTableMobileContent} funnelback-instant-search-comparisons-table-mobile-content`}
                                                >
                                                    Possible careers
                                                </h3>
                                                <ul>
                                                    {object?.listMetadata?.programCareers.map((career) => (
                                                        <li>{career}</li>
                                                    ))}
                                                </ul>
                                            </td>
                                        );
                                    }
                                    return '';
                                })}
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default Comparisons;
